import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";
import { CountryPhone } from "./CountryPhone";

// حقول التسجيل — الاسم/الإيميل + منتقي الدولة والهاتف + عدد الموظفين.
// كل عنصر: [key, label, type, required, span2] — span2=true يمتد على العمودين.
export const SIGNUP_FIELDS = [
  ["company_name", "signup.companyName", "text", true, false],
  ["contact_name", "signup.contactName", "text", true, false],
  ["contact_email", "signup.contactEmail", "email", true, true],
];

export const SignupFields = ({ form, setForm }) => {
  const { t } = useTranslation();
  return (
    <>
      {SIGNUP_FIELDS.map(([key, label, type, required, span2]) => (
        <div key={key} className={span2 ? "sm:col-span-2" : ""}>
          <p className="label-xs mb-2">{t(label)}</p>
          <NeuInput data-testid={`signup-${key}`} type={type} required={required}
                    value={form[key]}
                    onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
        </div>
      ))}
      <CountryPhone form={form} setForm={setForm} />
      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{t("signup.employees")}</p>
        <NeuInput data-testid="signup-employee_count" type="number" min={1} required
                  value={form.employee_count}
                  onChange={(e) => setForm({ ...form, employee_count: e.target.value })} />
        <p className="mt-1 text-xs text-muted-foreground">{t("signup.employeesHint")}</p>
      </div>
    </>
  );
};
